import { render } from "./dynamic-component-renderer.vue?vue&type=template&id=83ea80d0&scoped=true"
import script from "./dynamic-component-renderer.vue?vue&type=script&lang=js"
export * from "./dynamic-component-renderer.vue?vue&type=script&lang=js"

import "./dynamic-component-renderer.vue?vue&type=style&index=0&id=83ea80d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83ea80d0"]])

export default __exports__